import { OnboardingStep } from '../../../types/GloblalTypes';
var addEmployeeCell = "step-" + OnboardingStep.ONBOARDING_STEP_ADD_MEMBER;
var addPaymentCell = "step-" + OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD;
var addBudgetCell = "step-" + OnboardingStep.ONBOARDING_STEP_ADD_BUDGET;
var activateDashPassCell = "step-" + OnboardingStep.ONBOARDING_STEP_ACTIVATE_DASHPASS;
export var ChecklistTestIds;
(function (ChecklistTestIds) {
    ChecklistTestIds["getStartedButton"] = "getStartedButton";
    ChecklistTestIds["checklistItemTitle"] = "checklistItemTitle";
    ChecklistTestIds["checklistItemSubtext"] = "checklistItemSubtext";
})(ChecklistTestIds || (ChecklistTestIds = {}));
ChecklistTestIds[addEmployeeCell] = 'addEmployeeCell';
ChecklistTestIds[addPaymentCell] = 'addPaymentCell';
ChecklistTestIds[addBudgetCell] = 'addBudgetCell';
ChecklistTestIds[activateDashPassCell] = 'activateDashPassCell';
